module.exports = __webpack_public_path__ + "img/role02.ce7e3482.png";